<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="添加设备"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加设备</div>

      <el-form-item label="设备名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入设备名称" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="设备封面" >
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.cover" :src="form.cover" width="124" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
    </el-form-item>

    <el-form-item label="设备图片：" prop="image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.images">
          <transition-group>
            <div v-for="(item, index) in form.images" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openUploads">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

      <el-form-item label="设备终端号" prop="equip_no">
        <el-input v-model="form.equip_no" placeholder="请输入设备终端号" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="设备IMEI_安卓" prop="equip_imei">
        <el-input v-model="form.equip_imei" placeholder="请输入设备IMEI_安卓" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="设备IMEI_ios" prop="equip_imei_ios">
        <el-input v-model="form.equip_imei_ios" placeholder="请输入设备IMEI_ios" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="售后人员" prop="sales_people">
        <el-input v-model="form.sales_people" placeholder="请输入售后人员" class="max-w460"></el-input>
      </el-form-item>

      <el-form-item label="售后人员联系方式" prop="sales_phone">
        <el-input v-model="form.sales_phone" placeholder="请输入售后人员联系方式" class="max-w460"></el-input>
      </el-form-item>


      <el-form-item label="设备地址"  prop="address" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.address" :disabled="true" placeholder="请输入设备地址" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="设备坐标">
        <el-row class="mb16">
          <el-col :span="24">
            <el-input :disabled="true" v-model="form.coordinate" class="max-w460"></el-input>
          </el-col>
        </el-row>
        <el-row class="mb16">
          <el-col :span="24">
            <Getpoint :form="form" @getMapdata="getMapdataFunc" @chose="choseFunc"></Getpoint>
          </el-col>
        </el-row>

      </el-form-item>




      <el-form-item label="分佣类型" prop="type">
      <div >
          <el-radio-group v-model="form.type">
            <el-radio  :label="1" >分佣模式</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>

      <!-- <el-form-item label="招商中心比例" prop="filiale_rate">
        <el-input v-model="form.filiale_rate" placeholder="请输入招商中心比例" class="max-w460"></el-input>
        <span>%</span>
      </el-form-item>

      <el-form-item label="服务商比例" prop="service_rate">
        <el-input v-model="form.service_rate" placeholder="请输入服务商比例" class="max-w460"></el-input>
        <span>%</span>
      </el-form-item> -->


      <el-form-item label="设备详细说明">
      <div class="edit_container" >
        <Uediter :id="ue" v-model="form.content" :text1="form.content" :config="ueditor.config" ref="ue"></Uediter>
      </div>
    </el-form-item>




      <el-form-item label="状态" prop="status">
      <div >
          <el-radio-group v-model="form.status">
            <el-radio  :label="1" >开启</el-radio>
            <el-radio  :label="0" >关闭</el-radio>
          </el-radio-group>
      </div>
      </el-form-item>
      

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
  <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  <Upload v-if="isuploads" :isupload="isuploads" @returnImgs="returnImgsFuncs">上传图片</Upload>

</el-dialog>
  
</template>

<script>
import EquipApi from '@/api/equip.js';
import Getpoint from '@/components/map/Getpoint.vue';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
    Getpoint,
    Upload,
    draggable,
    Uediter,
  },
  data() {
    return {
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        },
      },
      /*form表单数据*/
      form: {
        name: '',
        content:"",
        equip_no:"",
        equip_imei:"",
        equip_imei_ios:"",
        sales_people:"",
        sales_phone:"",
        province_id:"",
        city_id:"",
        region_id:"",
        province:"",
        city:"",
        region:"",
        address:"",
        longitude:"",
        latitude:"",
        type:1,
        filiale_rate:"",
        service_rate:"",
        status:1,

        cover:"",
        images:[]


      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        equip_no: [{ required: true, message: '请输入设备终端号', trigger: 'blur' }],
        equip_imei: [{ required: true, message: '请输入设备IMEI', trigger: 'blur' }],
        sales_phone: [{ required: true, message: '请输入售后人员联系方式', trigger: 'blur' }],
        filiale_rate: [{ required: true, message: '请输入招商中心佣金比例', trigger: 'blur' }],
        service_rate: [{ required: true, message: '请输入服务商佣金比例', trigger: 'blur' }],
      },
      dialogVisible:false,
      isupload:false,
      isuploads:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
    getContent: function() {
      return this.$refs.ue.getUEContent();
    },
       /*删除商品图片*/
       deleteImg(index) {
      this.form.images.splice(index, 1);
    },

     /*获取图片*/
     returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.cover = e[0].file_path;

      }
      this.isupload = false;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFuncs(e) {
      if (e != null && e.length > 0) {
        for(var i=0;i<e.length;i++){
          this.form.images.push(e[i])
        }
       

      }
      this.isuploads = false;
    },
    /*上传*/
    openUploads(e) {
      this.isuploads = true;
    },




     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    /*选择的地址*/
    choseFunc(e){
        this.form.coordinate=e.location.lat+','+e.location.lng;
        this.form.address=e.address;

      },
       /*获取经纬度*/
       getMapdataFunc(e) {
        this.form.coordinate = e.data[0].toFixed(6) + ',' + e.data[1].toFixed(6);
      },
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          if(form.images instanceof Array){
            form.images = JSON.stringify(form.images);
          }
          self.form.content = this.$refs.ue.getUEContent();
          EquipApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
.ad-picture {
  width: 110px;
  height: 110px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.ad-picture:hover {
  border: 1px dashed $blue;
}

.ad-picture img {
  object-fit: fill;
}

</style>



// WEBPACK FOOTER //
// src/views/plus/equip/equip/part/add.vue